export const PrivacyTypeToast = 'Please select an option to continue.'

export enum PrivacyType {
  Delete = 1,
  Access,
  Share,
  Communications,
  Other,
}

export const PrivacyTypeTitle = {
  title: 'Data Subject Request Form',
  description: [
    'In accordance with applicable data protection laws, you may have certain data privacy rights concerning your Personal Information. This page offers options for making requests related to these rights. Clicking on any of the options will either prompt you for additional information needed to process your request or direct you to a page for exercising a specific right.',
    'I would like to,',
  ],
}

export const PrivacySubjectTitle = {
  title: 'Data Subject Request Form',
  content: [
    'Please fill out the following information for us to process your request. Our actions will only be taken on the information provided below.',
    'Note: Fields marked with an asterisk (*) are required for us to verify your identity and process your request. Other fields are optional.',
  ],
}

export const PrivacyFormResult = {
  title: 'Thank you for submitting the Data Subject Request Form!',
  content: [
    'Please note that we may require additional information from you to properly process your request. We will provide you with information on any action taken with regard to your request within the time period required by applicable data protection laws. This period may be extended where necessary and permitted by law, and in such cases, you will be informed of any extension and the reasons for the delay.',
    'To confirm your identity, we may request that you provide proof of identity before taking any action to process your request. If you are acting as an authorized representative, you should be able to provide proof of your authority upon our request.',
    'We may refuse to act on your request on legitimate grounds, for which you will be duly notified. In some cases, we may charge a reasonable fee to cover the administrative costs of providing the information, communication, or taking the requested action.',
  ],
}

export const PrivacyTypeList = [
  {
    label: 'Request to delete your Personal Data',
    value: PrivacyType.Delete,
  },
  {
    label: 'Request to know/access to your Personal Data',
    value: PrivacyType.Access,
  },
  {
    label: 'Do not sell or share your Personal Data',
    value: PrivacyType.Share,
  },
  {
    label: 'Opt-out of marketing communications',
    value: PrivacyType.Communications,
  },
  {
    label: 'Request something other than the above',
    value: PrivacyType.Other,
  },
]

export const PrivacyTypeMap = Object.fromEntries(PrivacyTypeList.map(({ value, label }) => [value, label]))
